"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_MANUFACTURER_PERMISSIONS = exports.ManufacturerPermissions = void 0;
/**
 * Permission string catalog for Manufacturer Master (Stage 14, Phase 1 —
 * Pharmacy Master Data Foundation).
 */
exports.ManufacturerPermissions = {
    MANUFACTURER_MASTER_READ: 'manufacturer-master:read',
    MANUFACTURER_MASTER_CREATE: 'manufacturer-master:create',
    MANUFACTURER_MASTER_UPDATE: 'manufacturer-master:update',
    MANUFACTURER_MASTER_DELETE: 'manufacturer-master:delete',
    MANUFACTURER_MASTER_MANAGE: 'manufacturer-master:manage',
    MANUFACTURER_MASTER_APPROVE: 'manufacturer-master:approve',
};
exports.ALL_MANUFACTURER_PERMISSIONS = Object.values(exports.ManufacturerPermissions);
//# sourceMappingURL=manufacturer.permissions.js.map